import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
//Material
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
//Component
import { Modal } from "../../stories/modal";
import FormInput from "../../stories/hook-controls/input";
import { ReactTable } from "../../stories/react-table";
import * as alertDialog from "./../../utils/alert";
import MuiSelect from "./../../stories/hook-controls/select";
//Function
import { setDataToFormHookV2,isEmptyStr } from "../../utils/common-function";
import { buildParameter } from "./parameter";
import * as api from "./api";
import * as common from "./../../utils/common-function";
import { useHistory } from "react-router-dom";
import { API_URL } from "../../utils/api-utils";

function ModalExportAll(props) {
    const { open } = props;
    const history = useHistory();
    const { queryInfo, ...otherprops } = props;
    const method = useForm({ mode: "onChange" });
    const { register,setValue,getValues,setError, clearErrors, errors } = method;
    const [fileType, setFileType] = useState("");
    //const [queryString, setQueryString] =  useState(props?.queryInfo);
    useEffect(() => {
        if (!open) return;       
        //console.log(queryInfo);
      }, [queryInfo, setValue, open]);

    const ExportAll = async () =>{
        let param = buildParameter.ExportAll(queryInfo,getValues().QueryName,fileType);
        clearErrors("fileType");
        clearErrors("QueryName");
        if (common.isEmptyStr(param.fileType.trim())) {
            setError("fileType", { type: "CheckNull", message: "Please Select FileType." });
            return;
        }
        if (common.isEmptyStr(param.queryName.trim())) {
            setError("QueryName", { type: "CheckNull", message: "Please input QueryName." });
            return;
        }
        let res = await api.ExportAll(param);
        if (res.ResultCode === 10) { //connectSuccess
            props.onClose();
            alertDialog.Success("Success!");
            //history.push("/ExportQuery");
            window.open(`/ExportQuery`,'_blank');
        }
        if (res.ResultCode === 20) { //connectError
            alertDialog.ErrorDialog("Error : "+res.Message);
        }
        //console.log(res);
    }
    const listFileType =[ {id: "CSV",label: "CSV"} 
                        , {id: "TEXT",label: "TEXT"}];

    const ClearError = async (e) => {
        clearErrors(e.target.name);
    };

    const handleTypeChange = (event) => {
        //console.log(event.target.value);
        setFileType(event.target.value);
      };
    return (
        <>
      <Modal
        {...otherprops}
        title="Export"
        maxWidth="lg"
        SaveText="Export"
        onSave={ExportAll}
      >
        <FormProvider {...method}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Box flexGrow={1} className="box-input">
              <MuiSelect
              name="fileType"
              label="File Type"
              options={listFileType}
              errorobj={errors}
              required
              onChange={handleTypeChange}
              value={fileType}
            />
                <FormInput
                  variant="outlined"
                  name="QueryName"
                  label="QueryName"
                />
              </Box>
            </Grid>
          </Grid>
        </FormProvider>
      </Modal>
      </>
    );
}
export default ModalExportAll;
